var map = {
	"./2-2.png": "BPAh",
	"./2.png": "kdzh",
	"./25287.png": "a5yk",
	"./2灯泡.png": "x8lB",
	"./3.1定位.png": "auXv",
	"./404.png": "bhgG",
	"./Subscribecenter.png": "baHZ",
	"./abstract.png": "K+5z",
	"./address.png": "Sg/g",
	"./agricultural2.jpg": "DEZU",
	"./an.png": "6vZf",
	"./arrow.png": "LnfO",
	"./arrow.svg": "DDi5",
	"./background.jpg": "WNzc",
	"./biao.png": "SvFd",
	"./bookcase.png": "Ken9",
	"./bulblight.svg": "L9LJ",
	"./buy.png": "CIaQ",
	"./cc/CC BY-NC-ND.png": "zOG0",
	"./cc/CC BY-NC-SA.png": "xIH6",
	"./cc/CC BY-NC.png": "TBGF",
	"./cc/CC BY-ND.png": "R+M4",
	"./cc/CC BY-SA.png": "2Uca",
	"./cc/CC-0.png": "fWCF",
	"./cc/CC-BY.png": "6JHU",
	"./cc/Open access.png": "erCU",
	"./cc/Open access@2x.png": "Cy7a",
	"./cc/Open access@3x.png": "o1B6",
	"./center.png": "XDfd",
	"./circle chevron right 24_24.png": "9Qh9",
	"./circle-right.png": "UhcF",
	"./closedrawer.png": "DS2s",
	"./cloud.png": "X842",
	"./collect.png": "acd4",
	"./collect1.png": "uJXb",
	"./copy.png": "mnGE",
	"./cover1.png": "HlCU",
	"./cover2.png": "yVCm",
	"./cover3.png": "359V",
	"./cx.png": "XUuI",
	"./d.png": "VZSZ",
	"./doi.png": "k9Tv",
	"./education1.jpg": "K5M1",
	"./filtrate.png": "SCG2",
	"./footerlogo.png": "ksn0",
	"./footerp.png": "lA3/",
	"./full_text.png": "hZwb",
	"./head.png": "G1zB",
	"./high.png": "iM4C",
	"./hot.png": "dRkb",
	"./house.png": "EvuK",
	"./ico.png": "lLGQ",
	"./icon_+-.png": "cQki",
	"./icon_graphical.png": "HKC+",
	"./icon_graphical_close.png": "8r1N",
	"./jigou.png": "Fgj2",
	"./journalsci.png": "CQeT",
	"./key.png": "hN6p",
	"./keyWord.png": "xqXO",
	"./label.png": "wP8g",
	"./lianjie.png": "hNWD",
	"./linux.png": "UktJ",
	"./loading.gif": "3+W1",
	"./lock.png": "nfP8",
	"./lockjournal.png": "DVFu",
	"./logo.png": "Vpqn",
	"./logobackground.png": "xNR3",
	"./mac.png": "7nI4",
	"./mark.png": "jWip",
	"./medical.jpg": "vNDC",
	"./menu-icon.svg": "WF7i",
	"./no-recommend.jpg": "5If0",
	"./offshelf.png": "N8Bl",
	"./open.png": "lHPd",
	"./opendrawer.png": "dYQV",
	"./openlock.png": "Tlqn",
	"./originalText.png": "op6D",
	"./pdf.png": "tcik",
	"./photo.png": "URSd",
	"./picuter.png": "dWLq",
	"./quanbu.png": "UrWv",
	"./rack.png": "cEhX",
	"./rightright.png": "z4U9",
	"./science.jpg": "oa8H",
	"./science.png": "RUuL",
	"./search.png": "VssZ",
	"./social.png": "hMaq",
	"./subscription.png": "+h6O",
	"./subscription1.png": "LtxK",
	"./tongyong.png": "581I",
	"./tranlate.png": "mffx",
	"./translate.png": "5lEu",
	"./translatechinese.png": "9qrx",
	"./translatesearch.png": "lGtj",
	"./triangle.png": "tGbm",
	"./twojournal.png": "Tjr7",
	"./twojournal1.png": "fGo6",
	"./twoliterature.png": "mRjA",
	"./twoliterature1.png": "Opjo",
	"./u150.png": "6Stq",
	"./u181.png": "Fn0E",
	"./u6.png": "2tFt",
	"./unfilled-lg.png": "ENuF",
	"./usercenter.png": "a/Sa",
	"./vip-nav-normal.png": "DSm0",
	"./welcome.png": "CD6D",
	"./windows.png": "3bp4",
	"./year.png": "UqUL",
	"./youxian.png": "DOVa",
	"./yun.png": "kWZG",
	"./上.png": "6FON",
	"./下.png": "geTT",
	"./分享.png": "W/H0",
	"./切换 (1).png": "wlf6",
	"./图书.png": "Bmnb",
	"./图片.png": "8Dmz",
	"./新学术高影响力.png": "KkJ0",
	"./相似.png": "jLLl",
	"./警告.png": "K5YR",
	"./记录.png": "wiBK",
	"./返回顶部.png": "ZzlK"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "deFR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs ^\.\/.*$
// module id = deFR
// module chunks = 16